module.exports = __webpack_public_path__ + "static/media/2024.10.15 Initial Order - Mizrahi 1451.7e8c3a64.pdf";